import { render } from "./CookiesPage.vue?vue&type=template&id=f409f22a&scoped=true&ts=true"
import script from "./CookiesPage.vue?vue&type=script&lang=ts"
export * from "./CookiesPage.vue?vue&type=script&lang=ts"

import "./CookiesPage.vue?vue&type=style&index=0&id=f409f22a&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f409f22a"]])

export default __exports__